import React from 'react';
import { Link } from 'react-router-dom';

interface CTASectionProps {
  title: string;
  description: string;
  primaryButton?: {
    text: string;
    to: string;
  };
  secondaryButton?: {
    text: string;
    to: string;
  };
  className?: string;
}

const CTASection: React.FC<CTASectionProps> = ({
  title,
  description,
  primaryButton,
  secondaryButton,
  className = ''
}) => {
  return (
    <section className={`cta-section ${className}`}>
      <div className="container">
        <div className="cta-content">
          <h2>{title}</h2>
          <p>{description}</p>
          <div className="cta-buttons">
            {primaryButton && (
              <Link to={primaryButton.to} className="btn btn-primary">
                {primaryButton.text}
              </Link>
            )}
            {secondaryButton && (
              <Link to={secondaryButton.to} className="btn btn-outline">
                {secondaryButton.text}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
